import { cn } from 'lib/utils';
import { useTranslation } from 'react-i18next';

export const BlockedLabel = ({ status, className }: any) => {
    const { t } = useTranslation('translation');
    if (status !== 'BLOCKED') return null;
    return (
        <div className={cn('bg-orange-700 text-white px-1 font-medium text-xs h-[20px] leading-5', className)}>
            {t('filters.blocked').toLowerCase()}
        </div>
    );
};
